import { Box, Flex, Input, Text } from '@chakra-ui/react';
import { useRef } from 'react';
import { FileDrop } from 'react-file-drop';

const fileDropStyles = {
  '.file-drop': {
    h: '100%',
    border: '2px dashed',
    borderColor: 'gray.300',
    '.file-drop-target': { h: '100%' },
  },
};

interface Props {
  onDrop(files: FileList | null): void;
}

function Dropzone({ onDrop }: Props) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const onTargetClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  return (
    <Box h="400px" w="400px" bg="white" p={2} boxShadow="lg" sx={fileDropStyles}>
      <FileDrop onTargetClick={onTargetClick} onDrop={onDrop} className="file-drop">
        <Flex h="100%" justify="center" className="mojon" align="center">
          <Text fontSize={12} textAlign="center">
            DROP FILE HERE <br /> OR <br /> CLICK TO BROWSE
          </Text>
          <Input
            display="none"
            opacity={0}
            ref={fileInputRef}
            type="file"
            onChange={e => onDrop(e.target.files)}
          />
        </Flex>
      </FileDrop>
    </Box>
  );
}

export default Dropzone;
